module.exports = __webpack_public_path__ + "static/media/002.8e8a260f.jpg";